var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mt-5"},[_c('div',{staticClass:"card mt-3"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('SettingForm',{attrs:{"settings":_vm.settings,"url":_vm.url}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header border-0"},[_c('h5',{staticClass:"card-title font-bold"},[_vm._v("تنظیمات")])])
}]

export { render, staticRenderFns }